<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DpuLLJ/tc-custom/9781504019941.jpg?1694652062527" alt="This image is the cover for the book Which Way to Die?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Which Way to Die?
      </h1>
      <p class="bookDescription body article font2">
        <b>Tim Corrigan and Chuck Baer risk their necks to protect a pair of brilliant killers</b><br/><br/> When Chuck Baer and Tim Corrigan fought in Korea, they were known as the Deadly Duo. Now that they’re back in New York, Baer is working as a private eye and Corrigan is the only cop in the NYPD tough enough to wear an eye patch. They’re a long way from the army, but this duo never stopped being deadly.<br/>  <br/> Some 4 years ago, Corrigan had arrested Gerard Alstrom and Frank Grant, a pair of Columbia University freshmen who thought they were smart enough to commit the perfect murder. When a Miranda violation voids the killers’ conviction, it’s even money as to who will kill them 1st: the mob boss father of the girl they slaughtered, or her football star boyfriend. Corrigan is assigned to protect the bloodthirsty geniuses, whose sky-high IQs can’t save them from a bullet to the brain.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellery Queen
      </h2>
      
      <p class="authorDescription body article">Ellery Queen was a pen name created and shared by two cousins, Frederic Dannay (1905&ndash;1982) and Manfred B. Lee (1905&ndash;1971), as well as the name of their most famous detective. Born in Brooklyn, they spent forty-two years writing, editing, and anthologizing under the name, gaining a reputation as the foremost American authors of the Golden Age &ldquo;fair play&rdquo; mystery.&#160;Although eventually famous on television and radio, Queen&rsquo;s first appearance came in 1928, when the cousins won a mystery-writing contest with the book that would eventually be published as <i>The Roman Hat Mystery</i>. Their character was an amateur detective who uses his spare time to assist his police inspector uncle in solving baffling crimes. Besides writing the Queen novels, Dannay and Lee cofounded <i>Ellery Queen&rsquo;s Mystery Magazine</i>, one of the most influential crime publications of all time. Although Dannay outlived his cousin by nine years, he retired Queen upon Lee&rsquo;s death. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ec7e0d2